import type * as React from "react";
import { Link, type LinkProps } from "react-router-dom";
import { type ButtonProps, buttonStyle } from "@/components/ui/Button";
import { cn } from "@/lib/cn";

/** A router link with the Wanted Button look, for navigation that reads like an action. */
export function LinkButton({
  variant,
  color,
  size,
  style,
  className,
  ...rest
}: LinkProps & Pick<ButtonProps, "variant" | "color" | "size"> & { style?: React.CSSProperties }) {
  return (
    <Link
      className={cn("wds-pressable", className)}
      style={{ ...buttonStyle({ variant, color, size }), ...style }}
      {...rest}
    />
  );
}
